import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';

class NetworkPointDetailsActivitiesCtrl implements ng.IController {
    public networkPointId: number;
    public uiLoadingTradeProposals: boolean = true;
    public activityList: any = [];
    public uiPlaceBidSuccess = 'nwp-details-sta-bid-placed';
    public uiDeleteBidSuccess: boolean;

    constructor(
        private $rootScope,
        private Activity,
        private activitiesService,
        private auctionResource,
        private growl: Growl,
        private errorHandler: ErrorHandler
    ) {}

    $onInit(): void {
        this.getActivities();
    }

    public getActivities() {
        let from = new Date();
        from.setDate(from.getDate() - 30);

        this.Activity.query(
            { from: from, networkPoint: this.networkPointId },
            (res) => {
                this.activityList = this.activitiesService.map(res.data);
            },
            this.errorHandler
        );
    }

    public deleteBid(index, bidId) {
        this.auctionResource.deleteBid(
            { id: bidId },
            () => {
                delete this.activityList.activities[index];
                this.uiDeleteBidSuccess = true;
            },
            this.errorHandler
        );
    }

    public onStaBidSuccess() {
        this.$rootScope.$broadcast(this.uiPlaceBidSuccess);
        this.getActivities();
    }
}
angular.module('app').component('pkpNetworkPointDetailsActivities', {
    controller: NetworkPointDetailsActivitiesCtrl,
    template:
        require('app/network-point/network-point-details-activities.component.html'),
    bindings: {
        networkPointId: '<'
    }
});
